import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const BellSimpleZ = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="bellSimpleZ__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#bellSimpleZ__a)">
          <path
            d="M10.500589325,14C10.500589325,14.1326,10.447938925,14.2598,10.354139325,14.35355C10.260389325,14.4473,10.133189225,14.5,10.000589325,14.5L6.000589625,14.5C5.867989325,14.5,5.740839225,14.4473,5.647039625,14.35355C5.553289625,14.2598,5.500589625,14.1326,5.500589625,14C5.500589625,13.8674,5.553289625,13.7402,5.647039625,13.64645C5.740839225,13.5527,5.867989325,13.5,6.000589625,13.5L10.000589325,13.5C10.133189225,13.5,10.260389325,13.5527,10.354139325,13.64645C10.447938925,13.7402,10.500589325,13.8674,10.500589325,14ZM13.866239125,12C13.779489125,12.1528,13.653540125,12.27975,13.501339125,12.36765C13.349189125,12.4555,13.176339125,12.5012,13.000589125,12.5L3.000604395,12.5C2.824814555,12.49975,2.652194495,12.4532,2.500139475,12.365C2.348084445,12.27675,2.221974375,12.15,2.134509565,11.99755C2.047049522,11.84505,2.001329422,11.6722,2.0019595623016,11.4963999C2.00258946419,11.3205996,2.04954958,11.1480999,2.138104435,10.9962502C2.484979395,10.3987503,3.000604395,8.7087498,3.000604395,6.5C3.000604395,5.1739001,3.5273895250000002,3.9021499,4.4650695250000005,2.9644649000000003C5.402739325000001,2.0267849,6.674539525,1.5,8.000589325,1.5C9.326688725,1.5,10.598439225,2.0267849,11.536139525,2.9644649000000003C12.473839125,3.9021499,13.000589125,5.1739001,13.000589125,6.5C13.000589125,8.7081499,13.516839125,10.3987503,13.863739125,10.9962502C13.953189125,11.1483002,14.000489125,11.3214502,14.000790125,11.4978504C14.001140125,11.6743,13.954490125,11.8476,13.865589125,12L13.866239125,12ZM9.500589325,9C9.500589325,8.867400199999999,9.447938924999999,8.7402,9.354139325,8.64645C9.260389325,8.5527,9.133189224999999,8.5,9.000589325,8.5L7.938089325,8.5L9.419339225,6.2775002C9.469738925,6.2020001,9.498589525,6.1142001,9.502889625,6.02355C9.507139225,5.9329,9.486689525,5.8428001,9.443638825,5.7628999C9.400589025,5.6830001,9.336639425000001,5.6163001,9.258588825,5.5700002C9.180539125,5.5237002,9.091339125000001,5.499499800000001,9.000589325,5.5L7.000589325,5.5C6.867989525,5.5,6.740839025,5.5527,6.647039425,5.64645C6.553289425,5.7402,6.500589325,5.8674002,6.500589325,6C6.500589325,6.1325998,6.553289425,6.2598,6.647039425,6.35355C6.740839025,6.4473,6.867989525,6.5,7.000589325,6.5L8.066239325,6.5L6.584989525,8.7224998C6.534739525,8.7977505,6.505889925,8.8852501,6.501489625,8.9756498C6.497089425,9.0660496,6.517289125,9.155899999999999,6.559939425,9.2356997C6.602639225,9.3155003,6.666139625,9.3822498,6.743739125,9.4287996C6.821339625,9.4753504,6.910139125,9.4999504,7.000589325,9.5L9.000589325,9.5C9.133189224999999,9.5,9.260389325,9.4473,9.354139325,9.35355C9.447938924999999,9.2598,9.500589325,9.132599800000001,9.500589325,9Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
